import { URL } from '../../constants/provider/constant';
import { _axios } from '../../plugins/axios';

export const BulkConfirmAppointments = (data) => {
    let config = {
      method: 'post',
      url: URL.providercore_url+'provider/bulkRequestUpdate',
      headers: {
          accesstoken: JSON.parse(localStorage.getItem("access_token")),
        },
      data : {
        ...data,
        providerId: localStorage.getItem("user_details") ? JSON.parse(localStorage.getItem("user_details")).providerId: null
      }
    };
  
    return _axios(config)
      .then((response) => response.data)
      .catch((error) => error);
  }


export const SingleConfirmAppointments = (data) => {
    let config = {
      method: 'post',
      url: URL.providercore_url+'provider/updateRequest',
      headers: {
          accesstoken: JSON.parse(localStorage.getItem("access_token")),
        },
     data : {
       ...data,
       providerId: localStorage.getItem("user_details") ? JSON.parse(localStorage.getItem("user_details")).providerId: null
      }
    };
  
    return _axios(config)
      .then((response) => response.data)
      .catch((error) => error);
  }